import React from 'react';

import {css} from "@emotion/css";
import {useEffect, useState} from "react";
import {Box, Grid, Typography} from "@mui/material";
import "./FileManagerStyleSheet.css"
import {FileManagerService} from "./FileManagerService";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import FileManagerUploadNewImage from "./FileManagerUploadNewImage";
import {useRef} from "react";
import useDraggableScroll from "use-draggable-scroll";
import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import Pagination from "@mui/material/Pagination";
import PropTypes from "prop-types";
import {LoadingHelper} from "../../util/LoadingHelper";
import {
    convertCurrencyFormatPositiveNegative, convertUniversalDateTimeToPersianDateTime,
    DialogSize,
    RaikoAlert,
    raikoAlertTypes,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonPrimary,
    RaikoButtonSecondary, RaikoCustomTooltip,
    RaikoDefaultDialogPage, RaikoErrorSection,
    showErrorMessage, showInfoMessage,
    showSuccessMessage,
    prepareRaikoSelectBoxItem, RaikoSelectBox
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {RaikoErrorSectionVectors} from "../../util/RaikoErrorSectionVectors";

let selectedFileForDelete = -1
const FileManager = (
    {
        isDialog = false,
        defaultGalleryType = FileManagerTypes.LOCATION_THUMBNAILS,
        setSelectedFileUrl,
        setOpenDialog
    }) => {

    let page = 0;

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    const service = new FileManagerService()

    const [selectedFileMangerType, setSelectedFileMangerType] = useState(defaultGalleryType);
    const [itemCount, setItemCount] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [filesList, setFilesList] = useState([]);

    const [openHandleEndDialog, setOpenHandleEndDialog] = useState(false);

    const [selectedBucketId, setSelectedBucketId] = useState("");

    const handleClickOpenEndElectionDialog = () => {
        setOpenHandleEndDialog(true);
    };

    const handleCloseChangeEndElectionDialog = () => {
        selectedFileForDelete = -1
        setOpenHandleEndDialog(false);
    };

    const [needRefresh, setNeedRefresh] = useState(false);

    function doDeleteImage() {
        loading.show()
        service.deleteFile(FileManagerTypes, selectedFileForDelete)
            .then(_ => {
                showSuccessMessage("تصویر انتخاب شده با موفقیت حذف شد.")

                getListDataFromServer()
                handleCloseChangeEndElectionDialog()
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function getListDataFromServer() {
        loading.show()
        service.getImages(selectedFileMangerType, page)
            .then(response => {
                setFilesData(response)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function setFilesData(filesData) {
        setItemCount(filesData.numberOfItems)
        setPageCount(filesData.totalPage)
        setFilesList([])
        filesData.data.map(async (item, _) => {
            setFilesList(prevState => [
                ...prevState, {
                    url: item.url,
                    loadedImage: item.url,
                    realName: item.metadata.realName,
                    size: item.metadata.size,
                    uploadedAt: item.metadata.uploadedAt,
                    id: item.metadata.id,
                }
            ])
        })
    }

    const [openModal, setOpenModal] = useState(false)

    function handleCloseUploadModal() {
        setOpenModal(false)
        if (needRefresh) {
            setNeedRefresh(false)
            getListDataFromServer()
        }
    }

    function handleOpenUploadModal() {
        setOpenModal(true)
    }

    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});


    useEffect(() => {
        if (typeof selectedFileMangerType !== 'undefined') {
            page = 0
            getListDataFromServer()
        }
    }, [selectedFileMangerType])

    function doSelectGalleryFile(id) {
        if (isDialog) {
            loading.show()
            service.getPublicUrl(id)
                .then(response => {
                    setSelectedFileUrl(id, response.url)
                    setOpenDialog(false)
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })

        }
    }

    function handleChangePagination(event, value) {
        page = value - 1
        getListDataFromServer()
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.Files.name}</title>
            </Helmet>
            <FileManagerUploadNewImage
                needRefresh={setNeedRefresh}
                handleClose={handleCloseUploadModal}
                openModal={openModal}
                fileManagerType={selectedFileMangerType}
            />

            <RaikoDefaultDialogPage
                onClose={handleCloseChangeEndElectionDialog}
                open={openHandleEndDialog}
                selectedValue={""}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"حذف تصویر"}
            >
                <section className={css`display: flex;
                  flex-direction: column;
                  padding: 0 16px 16px 16px;
                  overflow-x: hidden !important;
                `}>

                    <div className="deleteDialogContainer">

                        <RaikoAlert
                            title={" آیا از حذف تصویر اطمینان دارید ؟!"}
                            type={raikoAlertTypes.warning}
                            description={["با حذف تصویر امکان بازیابی آن وجود نخواهد داشت !"]}
                        />

                    </div>

                    <div className="d-flex flex-column w-100">

                        <div className="deleteDialogButtonContainer">
                            <RaikoButtonSecondary label={" حذف کن"} onClick={doDeleteImage}/>
                            <RaikoButtonPrimary onClick={handleCloseChangeEndElectionDialog} label={"بیخیال"}/>
                        </div>
                    </div>
                </section>
            </RaikoDefaultDialogPage>

            <section className={css`
              padding: 26px;
              overflow: hidden !important;
              max-width: 100vw;
              flex-grow: 1;
              transition: var(--base-transition);
              background: var(--color-surface);
            `}>
                {!isDialog &&
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator("فایل ها", ""),
                        raikoBreadCrumbItemGenerator(selectedFileMangerType.name, ""),
                    ]}/>
                }

                <section
                    className={`${css`
                      display: flex;
                      flex-direction: column;
                    `}`}>
                    {!isDialog &&
                        <span className={css`
                          color: var(--color-text);
                          font-size: var(--text-size-default);
                          margin-top: 40px;
                        `}>
                    دسته ها
                    </span>}

                    {
                        !isDialog &&
                        <section className="galleryTypeItemsContainer hideScroll" ref={ref} onMouseDown={onMouseDown}>
                            <RaikoSelectBox
                                changeSelectItem={setSelectedBucketId}
                                items={fileManagerFolderList2}
                                defaultSelectedItem={selectedFileMangerType.id}

                            />

                        </section>
                    }
                    <section className="galleryPictureListDetails">
                        <section>
                            <Typography className="headerTitle">
                                لیست تصاویر
                            </Typography>
                            {itemCount > 0 ?
                                <Typography className={css`color: var(--color-text);
                                  font-size: var(--text-size-min) !important;
                                  margin-top: .5rem !important;`}>
                                    {" " + itemCount + " تصویر بارگزاری شده"}
                                </Typography> :
                                ''}
                        </section>
                        <RaikoButtonPrimary
                            label={"آپلود"}
                            className={css`
                              height: fit-content !important;
                            `}
                            onClick={handleOpenUploadModal}
                        />
                    </section>
                    <Box className="galleryItemList">
                        {filesList && filesList.length > 0 ?
                            filesList.map((file, index) => {
                                return <Grid key={index} xs={12} lg={12} md={12} sm={12}
                                             onClick={_ => doSelectGalleryFile(file.id)}
                                             className="galleryItemDetails default-card-container-background-style">
                                    <Grid xs={12} lg={9} md={9} sm={9} xl={9} className="galleryItemContent">
                                        <Grid xs={12} lg={9} md={9} sm={9} xl={9}>
                                            <img className="thumbnailImage default-card-container-background-style"
                                                 src={file.loadedImage}
                                                 alt="thumbnail"/>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={3} lg={2} xl={2} className="galleryItemTitleWrapper">
                                            <span className="galleryItemDescription">{file.realName}</span>
                                        </Grid>
                                    </Grid>
                                    <Grid className="date-and-volume">
                                        <Grid xs={3} sm={4} md={3} lg={2} xl={2} className="galleryItemWrapper">
                                            <span
                                                className="VIDEOize">{convertCurrencyFormatPositiveNegative(Math.ceil(file.size / 1024))} کیلوبایت</span>
                                        </Grid>
                                        <div className="galleryItemWrapper">
                                                     <span className="galleryItemDescription">
                                                      <div className={`ic-time`}/>
                                                         {file.uploadedAt ? convertUniversalDateTimeToPersianDateTime(file.uploadedAt) : "-"}
                                                      </span>
                                        </div>
                                    </Grid>
                                    <Grid xs={12} lg={3} md={3} sm={3} xl={3} className="buttonGroup">
                                        <div className="lineVisible ic-line"/>

                                        <a href={file.url} download={true}
                                           target={"_blank"} rel={"noreferrer"}>
                                            <RaikoCustomTooltip title="دانلود">
                                                <button className="btnAccess download-icon"/>
                                            </RaikoCustomTooltip>
                                        </a>
                                        <RaikoCustomTooltip title="کپی لینک">
                                            <button
                                                onClick={_ => {
                                                    navigator.clipboard.writeText(file.url)
                                                        .then(_ => {
                                                            showInfoMessage("لینک تصویر با موفقیت کپی شد.")
                                                        }).catch(_ => {
                                                        showErrorMessage("خطا در کپی کردن لینک تصویر!")

                                                    })
                                                }}
                                                className="btnAccess share-link-icon"/>
                                        </RaikoCustomTooltip>
                                        <RaikoCustomTooltip title="حذف">
                                            <button onClick={_ => {
                                                selectedFileForDelete = file.id
                                                handleClickOpenEndElectionDialog(true)
                                            }} className="btnAccess delete-icon"/>
                                        </RaikoCustomTooltip>
                                    </Grid>
                                </Grid>
                            }) :
                            <RaikoErrorSection image={RaikoErrorSectionVectors.EMPTY_LIST_ONE}/>
                        }
                        <div
                            className={css`
                              width: 100%;
                              display: flex;
                              justify-content: center;
                              align-content: center;
                              margin-top: 16px;
                            `}>
                            <Pagination
                                count={pageCount}
                                shape="rounded"
                                onChange={handleChangePagination}
                                className={pageCount && pageCount > 0 ? "" : css`display: none`}
                            />
                        </div>
                    </Box>

                </section>
            </section>
        </>
    )
}
export default FileManager;

FileManager.propTypes = {
    isDialog: PropTypes.bool,
}

export const fileTypes = {
    "IMAGE": "IMAGE",
    "VIDEO": "VIDEO",
    "AUDIO": "AUDIO",
    "APK": "APK",
}

export const FileManagerTypes = {
    "MARTYRS_PHOTOS": {
        id: "MARTYRS_PHOTOS",
        name: "تصاویر شهدا",
        uploadUrl: "buckets/MARTYRS_PHOTOS/files",
        type: fileTypes.IMAGE,
        icon: "ic-files"
    },
    "LOCATION_PHOTOS": {
        id: "LOCATION_PHOTOS",
        name: "تصاویر مکان ها",
        uploadUrl: "buckets/LOCATION_PHOTOS/files",
        type: fileTypes.IMAGE,
        icon: "ic-files"
    },
    "LOCATION_THUMBNAILS": {
        id: "LOCATION_THUMBNAILS",
        name: "شاخص مکان ها",
        uploadUrl: "buckets/LOCATION_THUMBNAILS/files",
        type: fileTypes.IMAGE,
        icon: "ic-files"
    },
    "ADMINS_AVATARS": {
        id: "ADMINS_AVATARS",
        name: "آواتار ادمین",
        uploadUrl: "buckets/ADMINS_AVATARS/files",
        type: fileTypes.IMAGE,
        icon: "ic-files"
    },
    "MARTYRS_AVATARS": {
        id: "MARTYRS_AVATARS",
        name: "آواتار شهدا",
        uploadUrl: "buckets/MARTYRS_AVATARS/files",
        type: fileTypes.IMAGE,
        icon: "ic-files"
    },
    "POST_IMAGES": {
        id: "POST_IMAGES",
        name: "تصاویر مجله",
        uploadUrl: "buckets/POST_IMAGES/files",
        type: fileTypes.IMAGE,
        icon: "ic-files"
    },
    "POST_THUMBNAILS": {
        id: "POST_THUMBNAILS",
        name: "شاخص مجله",
        uploadUrl: "buckets/POST_THUMBNAILS/files",
        type: fileTypes.IMAGE,
        icon: "ic-files"
    },
    "APK": {
        id: "APK",
        name: "نسخه ها",
        uploadUrl: "buckets/APK/files",
        type: fileTypes.APK,
        icon: "ic-files"
    },
    "VIDEO": {
        id: "VIDEO",
        name: "ویدیو ها",
        uploadUrl: "buckets/VIDEO/files",
        type: fileTypes.VIDEO,
        icon: "ic-video-post"
    },
    "AUDIO": {
        id: "AUDIO",
        name: "صوت ها",
        uploadUrl: "buckets/AUDIO/files",
        type: fileTypes.AUDIO,
        icon: "ic-podcast-post"
    },
    "POST_CATEGORY_ICON": {
        id: "POST_CATEGORY_ICON",
        name: "آیکون دسته بندی",
        uploadUrl: "buckets/POST_CATEGORY_ICON/files",
        type: fileTypes.IMAGE,
        icon: "ic-podcast-post"
    },
    "POST_CATEGORY_IMAGE": {
        id: "POST_CATEGORY_IMAGE",
        name: "تصویر شاخص دسته بندی",
        uploadUrl: "buckets/POST_CATEGORY_IMAGE/files",
        type: fileTypes.IMAGE,
        icon: "ic-podcast-post"
    },
    "TOUR_LEADER_AVATARS": {
        id: "TOUR_LEADER_AVATARS",
        name: "آواتار لیدر",
        uploadUrl: "buckets/TOUR_LEADER_AVATARS/files",
        type: fileTypes.IMAGE,
        icon: "ic-podcast-post"
    },
    "TOUR_IMAGE": {
        id: "TOUR_IMAGE",
        name: "تصاویر تور ها",
        uploadUrl: "buckets/TOUR_IMAGE/files",
        type: fileTypes.IMAGE,
        icon: "ic-files"
    },
    "TOUR_ITINERARY_IMAGE": {
        id: "TOUR_ITINERARY_IMAGE",
        name: "تصاویر برنامه سفر تور ها",
        uploadUrl: "buckets/TOUR_ITINERARY_IMAGE/files",
        type: fileTypes.IMAGE,
        icon: "ic-files"
    },
    "POST_WRITER_AVATARS": {
        id: "POST_WRITER_AVATARS",
        name: "آواتار نویسنده",
        uploadUrl: "buckets/POST_WRITER_AVATARS/files",
        type: fileTypes.IMAGE,
        icon: "ic-podcast-post"
    },
    "ADMIN_AVATARS": {
        id: "ADMIN_AVATARS",
        name: "آواتار ادمین",
        uploadUrl: "buckets/ADMIN_AVATARS/files",
        type: fileTypes.IMAGE,
        icon: "ic-podcast-post"
    },
    "PREDEFINED_AVATAR": {
        id: "PREDEFINED_AVATAR",
        name: "آواتار کاربر",
        uploadUrl: "buckets/PREDEFINED_AVATAR/files",
        type: fileTypes.IMAGE,
        icon: "ic-podcast-post"
    },
    "GAME_THUMBNAILS": {
        id: "GAME_THUMBNAILS",
        name: "تصاویر شاخص بازی",
        uploadUrl: "buckets/GAME_THUMBNAILS/files",
        type: fileTypes.IMAGE,
        icon: "ic-files"
    },
}

const fileManagerFolderList2 = [
    prepareRaikoSelectBoxItem(FileManagerTypes.LOCATION_THUMBNAILS.id, FileManagerTypes.LOCATION_THUMBNAILS.name),
    prepareRaikoSelectBoxItem(FileManagerTypes.LOCATION_PHOTOS.id, FileManagerTypes.LOCATION_PHOTOS.name),
    prepareRaikoSelectBoxItem(FileManagerTypes.POST_IMAGES.id, FileManagerTypes.POST_IMAGES.name),
    prepareRaikoSelectBoxItem(FileManagerTypes.POST_THUMBNAILS.id, FileManagerTypes.POST_THUMBNAILS.name),
    prepareRaikoSelectBoxItem(FileManagerTypes.MARTYRS_PHOTOS.id, FileManagerTypes.MARTYRS_PHOTOS.name),
    prepareRaikoSelectBoxItem(FileManagerTypes.MARTYRS_AVATARS.id, FileManagerTypes.MARTYRS_AVATARS.name),
    prepareRaikoSelectBoxItem(FileManagerTypes.APK.id, FileManagerTypes.APK.name),
    prepareRaikoSelectBoxItem(FileManagerTypes.PREDEFINED_AVATAR.id, FileManagerTypes.PREDEFINED_AVATAR.name),
]
